import React from 'react'

import type { FilterHeaderProps } from '../../types/components/FilterHeader'
import './filter-header.scss'

export default function FilterHeader({
  selectedFacets = [],
  onApply,
  cleanUpFacets,
  type,
  dismissTransition,
  isDesktop,
}: FilterHeaderProps) {
  return (
    <div className="filter-header-container">
      {isDesktop ? (
        <header className="filter-header">
          <div className="filter-header__content">
            {type === 'price' ? (
              <>
                <p className="filter-header__title">CRIE SUA FAIXA DE PREÇO</p>
                <p className="filter-header__text">Faixa Selecionada</p>
              </>
            ) : (
              <span className="facets-quantity">
                {selectedFacets?.length} selecionado(s)
              </span>
            )}
            <div className="facets">
              {selectedFacets?.map((facet, i) => (
                <span key={i}>
                  {facet.value}
                  {i !== selectedFacets.length - 1 && <span>,</span>}
                </span>
              ))}
            </div>
          </div>
          <div className="filter-header__controls">
            <button onClick={onApply}>
              {selectedFacets?.length > 1
                ? 'APLICAR FILTROS'
                : 'APLICAR FILTRO'}
            </button>
            <button
              onClick={() => {
                dismissTransition?.current?.()
                cleanUpFacets()
              }}
            >
              LIMPAR
            </button>
          </div>
        </header>
      ) : (
        <header className="filter-header">
          <div className="filter-header__controls">
            <button
              className="filter-header__controls-applyButton"
              onClick={onApply}
            >
              {selectedFacets?.length > 1
                ? 'APLICAR FILTROS'
                : 'APLICAR FILTRO'}
            </button>
          </div>
        </header>
      )}
    </div>
  )
}
